import { SET_IS_NEW_USER_TOUR } from '../actions/onboarding-actions-types'

const INITIAL_STATE_SET_IS_NEW_USER_TOUR = { results: '' }

export function setIsNewUserTourReducer(state = INITIAL_STATE_SET_IS_NEW_USER_TOUR, action) {
    switch (action.type) {
        case SET_IS_NEW_USER_TOUR:
            return { results: action.payload }
        default:
            return state;
    }
}